import { httpGet } from "../../../../../common/network/fetch";
import { BtmReturnRequest, IBtmReturnRequestDto } from "../../model/btm-return-request";

export const GetReturnRequestHandler = async (returnRequestId: string) => {
    return new BtmReturnRequest((await httpGet<{ returnRequestsData: IBtmReturnRequestDto }>({
        url: `/return-request/${returnRequestId}`,
    }, false)).returnRequestsData);
};
